<div class="card card-statistics mb-30" [hidden]="Form_Switcher!='List'" >
  <div class="card-body">
    <div class="float-left">
      <h5 class="card-title">
        Select a Customer Letter for Scheduling
        <span *ngIf="Procssing_LetterRequestCustomer">(Loading information...)</span>
      </h5>
    </div>

    <div style="clear: both;"></div>
    <div class="row">
      <div  class="form-group col-md-6" >
        <button *ngIf="!Procssing_LetterRequestCustomer" type="button" (click)="ReadData_Letter()"  class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-search"></i> Refresh </button>
      </div>
     </div>
    <div class="row">
      <div class="form-group col-md-6">
        <label for="exampleInputEmail1">Customer Name</label>
        <input [(ngModel)]="Filter_CustomerName" name="Filter_CustomerName" type="text" class="form-control"
          placeholder="Type here to search...">
      </div>
      <div class="form-group col-md-6">
        <label for="exampleInputEmail1"> Letter Number </label>
        <input [(ngModel)]="Filter_LetterCode" name="Filter_LetterCode" type="text" class="form-control"
          placeholder="Type here to search...">
      </div>

    </div>


    <div class="row">
      <div class="col-md-4 mb-30" *ngFor="let item of DataList_LetterRequestCustomer
            |filter:Filter_CustomerName:'customer'
            |filter:Filter_LetterCode:'code'
            | paginate
                    : {
                        id: 'DataList_UserTable',
                        itemsPerPage: 15,
                        currentPage: page,
                        totalItems: (DataList_LetterRequestCustomer
                        |filter:Filter_CustomerName:'customer'
                        |filter:Filter_LetterCode:'code'
                        ).length
                      }
            ">

        <div class="card h-100">
          <div class="card-body">
            <h5 class="card-title"> Letter Number '{{item.code}}' </h5>
            <h6> {{item.customer}} </h6>
            <p> Address Customer : {{item.giver_name}}  </p>
            <p> Active Missions : {{item.status}} items </p>
            <hr>
            <button style="margin-right: 5px;" (click)="On_Set_Form_Switcher('ScheduleForm',item)" class="btn btn-info"><i class="fa fa-id-badge"></i> Schedule </button>
            <a target="_blank" style="margin-right: 5px;" href="{{BaseUrl1}}{{item.id}}" class="btn btn-success"><i class="fa fa-file-pdf-o"></i> Time Notification Letter </a>
            <button (click)="On_Set_Form_Switcher('Activity',item)" class="btn btn-warning"><i class="fa fa-wpforms"></i> Events </button>
          </div>
        </div>
      </div>
    </div>
    <pagination-controls id="DataList_UserTable"
     nextLabel="Next"
     previousLabel="Previous"
     (pageChange)="page = $event"
   ></pagination-controls>
  </div>
</div>

<div  *ngIf="Form_Switcher=='ScheduleForm'">
  <app-ScheduleLetterForm [inner_Letter_record]="Selected_DataList_LetterRequestCustomer">

  </app-ScheduleLetterForm>
  <a target="_blank" style="margin-right: 5px;" href="{{BaseUrl1}}{{Selected_DataList_LetterRequestCustomer.id}}" class="btn btn-success"><i class="fa fa-file-pdf-o"></i> Time Notification Letter </a>
  <a target="_blank" style="margin-right: 5px;" href="{{BaseUrl2}}{{Selected_DataList_LetterRequestCustomer.id}}" class="btn btn-info"><i class="fa fa-file-pdf-o"></i> Equipment Letter </a>
  <a target="_blank" style="margin-right: 5px;" href="{{BaseUrl3}}{{Selected_DataList_LetterRequestCustomer.id}}" class="btn btn-warning"><i class="fa fa-file-pdf-o"></i> Mission Letter </a>



  <button (click)="SwichActivityDevice(Selected_DataList_LetterRequestCustomer)" *ngIf="Selected_DataList_LetterRequestCustomer.dscVisible" type="button" class="btn btn-success" style="margin-right: 5px;">
    <i class="fa fa-eye"></i> Show Remarks in PDF
  </button>
  <button (click)="SwichActivityDevice(Selected_DataList_LetterRequestCustomer)" *ngIf="!Selected_DataList_LetterRequestCustomer.dscVisible" type="button" class="btn btn-danger" style="margin-right: 5px;">
    <i class="fa fa-eye-slash"></i>  Hide Remarks in PDF
  </button>

  <button (click)="SwichActivityVisible(Selected_DataList_LetterRequestCustomer)" *ngIf="Selected_DataList_LetterRequestCustomer.activityVisible" type="button" class="btn btn-success" style="margin-right: 5px;">
    <i class="fa fa-eye"></i> Show Events in PDF
  </button>
  <button (click)="SwichActivityVisible(Selected_DataList_LetterRequestCustomer)" *ngIf="!Selected_DataList_LetterRequestCustomer.activityVisible" type="button" class="btn btn-danger" style="margin-right: 5px;">
    <i class="fa fa-eye-slash"></i>  Hide Events in PDF
  </button>


  <button (click)="On_Back_Form_Switcher()" type="button" class="btn btn-warning" style="margin-left: 10px;"><i class="fa fa-mail-reply"></i> Back </button>


</div>


<div class="card card-statistics mb-30" *ngIf="Form_Switcher=='Activity'">
  <div class="card-body">
    <div class="float-left">
      <h5 class="card-title">
        Events for Letter Number '{{Selected_DataList_LetterRequestCustomer.id}}'
      </h5>
    </div>
    
    <div style="clear: both;"></div>

    <app-LetterRequestCustomerMissionActivity
    [inner_Letter_id]="Selected_DataList_LetterRequestCustomer.id"
    [inner_Customer_id]="Selected_DataList_LetterRequestCustomer.customerId">

  </app-LetterRequestCustomerMissionActivity>

  <app-LetterRequestCustomerMissionActivityList
  [inner_Letter_id]="Selected_DataList_LetterRequestCustomer.id"
  [inner_Customer_id]="Selected_DataList_LetterRequestCustomer.customerId">

</app-LetterRequestCustomerMissionActivityList>

  <button (click)="On_Back_Form_Switcher()" type="button" class="btn btn-warning" style="margin-left: 10px;"><i class="fa fa-mail-reply"></i> Back </button>

  </div>
</div>
